import { CUSTOMIZER_REDUCER_NAME, CustomizerReducer } from '@europrocurement/l2d-modules';

export { customizerSelector } from '@europrocurement/l2d-modules';

// Generate Redux Store Structure

export const standaloneReducerBase = {
    [CUSTOMIZER_REDUCER_NAME]: CustomizerReducer,
};
